// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_9u-2";
export var aiChatCartContainerExit = "_9u-4";
export var aiChatContainerLarge = "_9u-0";
export var aiChatContainerSmall = "_9u-1";
export var aiChatIcon = "_9u-6";
export var slideInFromRight = "_9u-3";
export var slideOutToRight = "_9u-5";